import * as React from 'react';

import ImpressionTracker from '../analytics/impression-tracker/ImpressionTracker';
import {Input} from '../ui/forms/Input/Input';
import {OrdersService} from '../../client/orders/orders.service';
import {ProductImage} from '../ui/ProductImage/ProductImage';
import {PromoItem} from './promo.class';
import {Radio} from '../ui/forms/Radio/Radio';
import {useService} from '../react/ServiceContext';
import {Badge} from '../ui/Badges/Badge';

interface PromoCardProps {
    onSelect: (itemNum: string) => void;
    onSelectEmail: (email: string) => void;
    onSelectTier: (index: string) => void;
    promoItem: PromoItem;
    promoItemIndex: number;
    promoTierOptionIndex: number;
    selectedPromoEmail: string;
    selection: string;
}

export const PromoCard = ({
    onSelect,
    onSelectEmail,
    onSelectTier,
    promoItem,
    promoItemIndex,
    promoTierOptionIndex,
    selectedPromoEmail,
    selection,
}: PromoCardProps) => {
    const componentName = `PromoCard`;
    const ordersService: OrdersService = useService(`ordersService`);

    /**
     * Template
     */
    return (
        <div className="tw-relative tw-flex tw-flex-col tw-bg-white tw-border tw-min-w-0 tw-rounded-sm tw-mb-4">
            <div className="tw-relative tw-flex tw-flex-col tw-bg-white tw-min-w-0 tw-rounded-sm tw-h-full tw-mb-2">
                <div className="tw-p-4">
                    <Radio
                        alias={`promoItemOption${promoTierOptionIndex}-${promoItemIndex}`}
                        checked={promoItem.selected || selection === promoItem.item}
                        disabled={!promoItem.qualify}
                        label="Selected Item"
                        name="selected-item"
                        onChange={() => {
                            onSelect(promoItem.item);
                            onSelectTier(`${promoTierOptionIndex + 1}`);
                        }}
                        value={promoItem.item}
                    />
                    <div className="tw-mb-4">
                        {promoItem.limitReached && <Badge variant="light">ALL REDEEMED</Badge>}
                        {promoItem.itemType === `gift` && (
                            <>
                                <div className="tw-mb-4 tw-pt-2">{promoItem.h1HTML || promoItem.itemDesc}</div>
                                <div className={`tw-mb-4 ${selection !== promoItem.item ? 'tw-hidden' : ''}`}>
                                    <Input
                                        id={`promoItemEmail${promoTierOptionIndex}-${promoItemIndex}`}
                                        label="Email of Gift Card Recipient"
                                        name="promo-email"
                                        onChangeString={(thisValue) => {
                                            onSelectEmail(thisValue);
                                        }}
                                        type="text"
                                        autocorrect="off"
                                        value={promoItem.emailAddress || selectedPromoEmail}
                                    />
                                </div>
                            </>
                        )}
                        {promoItem.itemType === `item` && (
                            <ImpressionTracker
                                as="span"
                                data={{
                                    dimension16: ordersService?.currentOrderNumber,
                                    index: promoTierOptionIndex,
                                    item_id: promoItem.item,
                                    item_list_name: componentName,
                                }}
                            >
                                <a href={`/item/${promoItem.item}`}>{promoItem.h1HTML || promoItem.itemDesc}</a>
                            </ImpressionTracker>
                        )}
                    </div>
                    <ProductImage
                        altText={promoItem.itemDesc}
                        size={120}
                        src={promoItem.imagePath}
                    />
                </div>
            </div>
        </div>
    );
};
